import type { PaymentMethodsConfig } from '../default/payment';
import type { DeepPartial } from '../default/types';

export const paymentMethodsConfig: DeepPartial<PaymentMethodsConfig> = {
  paymentMethods: {
    imageBased: ['paypal', 'mastercard', 'visa', 'diners', 'discover'],
    textBased: ['invoice', 'flexikonto'],
  },
  // ORDER-4147: QDE opts in to the invoice/installments credit-check hint.
  showCreditCheckHint: true,
};
